export const head = [
    {
        name: "Adarsh Singh chauhan",
        post: "President"
    },
    {
        name: "Kalpna Shukla",
        post: "Vice President"
    },
    {
        name: "Arshveer Singh",
        post: "Photography Head"
    },
    {
        name: "Saksham Sahu",
        post: "Events Head"
    },
    {
        name: "Aanshi Mishra",
        post: "Finance Head"
    },
    {
        name: "Akancha Singh Kanoujia",
        post: "Hospitality Head"
    },
    {
        name: "Mukul dubey",
        post: "Web development Head"
    },
]

export const financeHeads = [
    {
        name: "Virat mishra",
        post: "Associate Finance Head"
    },
    {
        name: "Ayush Mishra",
        post: "Associate Finance Head"
    },
    {
        name: "Sonam rajput",
        post: "Associate Finance Head"
    },
    {
        name: "Tanya shivhare",
        post: "Associate Finance Head"
    },
]

export const photographyHeads = [
    {
        name: "Shobhit Vishwakarma",
        post: "Associate Photography Head"
    },
    {
        name: "Shreya Trivedi",
        post: "Associate Photography Head"
    },
    {
        name: "Jatin Rastogi",
        post: "Associate Photography Head"
    },
]

export const hospitalityHeads = [
    {
        name: "Vikas Kumar Mourya",
        post: "Associate Hospitality Head"
    },
    {
        name: "Mohammad Sarfaraz",
        post: "Associate Hopitality Head"
    },
    {
        name: "Ashutosh Singh",
        post: "Associate Hospitality Head"
    },
]

export const eventHeads = [
    {
        name: "Vedansh Singh",
        post: "Associate Event Head"
    },
    {
        name: "Himani Singh",
        post: "Associate Event Head"
    },
    {
        name: "Saurabh Prajapati",
        post: "Associate Event Head"
    },
    {
        name: "Ayush Sharma",
        post: "Associate Event Head"
    },
]

export const techHead = [
    {
        name: "Aryan Singh",
        post: "Associate Tech Head"
    },
    {
        name: "Arya Gupta",
        post: "Associate Tech Head"
    },
    {
        name: "Ritik Saxena",
        post: "Associate Tech Head"
    },
]

export const volunteer = [
    {
        name: "Kashif Akhtar",
        post: "Volunteer"
    },
    {
        name: "Shikhar Verma",
        post: "Volunteer"
    },
    {
        name: "Sneha Trivedi",
        post: "Volunteer"
    },
]